module.exports = __webpack_public_path__ + "static/media/IMG-3.31633ce4.jpg";